import React from "react";
import { HelpCircle } from "lucide-react";
import { cn } from "@/lib/utils";

interface Chat8PerguntasPanelHeaderProps {
  isConnected: boolean;
  messagesModalTrigger?: React.ReactNode;
  debugModalTrigger?: React.ReactNode;
}

export const Chat8PerguntasPanelHeader: React.FC<Chat8PerguntasPanelHeaderProps> = React.memo(
  ({ isConnected, messagesModalTrigger, debugModalTrigger }) => {
    return (
      <div
        id="chat8-perguntas-header"
        className="chat8-perguntas-header flex items-center justify-between px-4 py-3 bg-navy-900/80 backdrop-blur-sm border-b border-white/5"
        data-testid="chat8-perguntas-header"
      >
        {/* Title with icon */}
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 rounded-lg bg-white/10 flex items-center justify-center">
            <HelpCircle className="w-4 h-4 text-blue-400" />
          </div>
          <h3
            id="chat8-perguntas-title"
            className="chat8-perguntas-title text-platinum text-base font-semibold m-0"
            data-testid="chat8-perguntas-title"
          >
            Perguntas do Assistente
          </h3>
        </div>

        {/* Status with glassmorphism and buttons */}
        <div className="flex items-center gap-3">
          {debugModalTrigger && (
            <div className="debug-modal-trigger">
              {debugModalTrigger}
            </div>
          )}
          {messagesModalTrigger && (
            <div className="messages-modal-trigger">
              {messagesModalTrigger}
            </div>
          )}
          {/* Connection status */}
          <div className="glass-card px-3 py-1.5 rounded-full border border-white/10">
            <div
              id="chat8-perguntas-status"
              className="chat8-perguntas-status flex items-center gap-2"
              data-testid="chat8-perguntas-status"
            >
            <div
              id="chat8-connection-indicator"
              className={cn(
                "chat8-connection-indicator w-2 h-2 rounded-full",
                isConnected ? "connected bg-emerald-500" : "disconnected bg-red-500"
              )}
              data-testid="chat8-connection-indicator"
            />
            <span
              id="chat8-connection-text"
              className={cn(
                "chat8-connection-text text-xs font-medium",
                isConnected ? "text-emerald-500" : "text-red-500"
              )}
              data-testid="chat8-connection-text"
            >
              {isConnected ? "Conectado" : "Desconectado"}
            </span>
            </div>
          </div>
        </div>
      </div>
    );
  }
);

Chat8PerguntasPanelHeader.displayName = "Chat8PerguntasPanelHeader"; 